
import _ from 'lodash';

const namespaced = true;

const state = {
  email: ``,
  firstname: ``,
  lastname: ``,
  password: ``,
  repeatPassword: ``,
  isPasswordInit: false,
  initAccountToken: null,
  initAccountData: {},
};

const mutations = {
  SET_EMAIL(state, email) {
    state.email = email;
  },
  SET_FIRSTNAME(state, firstname) {
    state.firstname = firstname;
  },
  SET_LASTNAME(state, lastname) {
    state.lastname = lastname;
  },
  SET_PASSWORD(state, password) {
    state.password = password;
  },
  SET_REPEAT_PASSWORD(state, repeatPassword) {
    state.repeatPassword = repeatPassword;
  },
  SET_INIT_ACCOUNT_TOKEN(state, initAccountToken) {
    state.initAccountToken = initAccountToken;
  },
  SET_INIT_ACCOUNT_DATA(state, initAccountData) {
    state.initAccountData = initAccountData;
  },
};

const actions = {
  async getInitAccountData({ state, commit, dispatch }) {
    const initAccountData = await dispatch(`model/auth/getInitAccountData`, {
      token: state.initAccountToken,
    }, { root: true });

    if (initAccountData && initAccountData.email) {
      initAccountData.email = _.trim(initAccountData.email);
    }

    commit(`SET_INIT_ACCOUNT_DATA`, initAccountData);
  },
  async initAccount({ state, commit, dispatch }) {
    const user = await dispatch(`model/auth/initAccount`, {
      token: state.initAccountToken,
      email: state.email,
      firstname: state.firstname,
      lastname: state.lastname,
      password: state.password,
    }, { root: true });

    if (user) {
      commit(`ui/login/SET_USERNAME`, state.email, { root: true });
      commit(`ui/login/SET_PASSWORD`, state.password, { root: true });
    }
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
